import { CircularProgress } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

const ButtonPrimary = (props) => {
  const {
    text,
    onClick,
    className,
    loading,
    link,
    size = "md",
    iconLeft,
    iconRight,
    variant = "primary",
    target,
  } = props;
  return link ? (
    <Link className={`btn-primary ${size} ${variant} ${className}`} onClick={onClick} to={link} target={target}>
      <div className="flex">
        {iconLeft && <div className="icon-left">{iconLeft}</div>}
        <p>{text}</p>
        {iconRight && <div className="icon-right">{iconRight}</div>}
      </div>
    </Link>
  ) : (
    <div className={`btn-primary ${size} ${variant} ${className}`} onClick={onClick}>
      {loading ? (
        <div className="icon-left">
          <CircularProgress size={size === "sm" ? "1.25rem" : size === "md" ? "1.5rem" : "2rem"} />
        </div>
      ) : iconLeft ? (
        <div className="icon-left">{iconLeft}</div>
      ) : null}
      <p>{text}</p>
      {iconRight && <div className="icon-right">{iconRight}</div>}
    </div>
  );
};

export default ButtonPrimary;
